KMVP.searchandpagination = {
    bindSortLinks: function () {
        $('.js-sort-link').on('click', function (e) {
            var $this = $(this);
            var sortBy = $this.data("sort-by");
            var newOrder = $this.hasClass('asc') ? 'desc' : 'asc';
            var form = $('.js-searchandpagination-form');

            form.find('input[name="sort"]').val(sortBy + '|' + newOrder);
            form.submit();
        });
    },
    bindPaginationLinks: function () {
        $('.js-pagination-link').on('click', function (e) {
            var pageNo = $(this).data("page-no");
            var form = $('.js-searchandpagination-form');

            form.find('input[name="currentPage"]').val(pageNo);
            form.submit();
        });
    },
    bindInputChangeToResetCurrentPage: function () {
        $('.js-searchandpagination-form input').on("change", function (event) {
            var inputName = $(this).attr('name');

            // need to reset current page, if any input changes except of currentPage and sort
            if(inputName != 'currentPage' && inputName != 'sort') {
                $('.js-searchandpagination-form input[name="currentPage"]').val(0);
            }
        });
    },
    updateUiFromFormAndBindLinks: function () {
        KMVP.searchandpagination.bindSortLinks();
        KMVP.searchandpagination.bindPaginationLinks();

        var sort = $('.js-searchandpagination-form input[name="sort"]').val();
        var sortParts = sort.split('|');

        var sortBy = sortParts[0];
        var order = sortParts[1];

        $('.js-sort-link').each(function () {
            var $this = $(this);
            if (sortBy === $this.data("sort-by")) {
                $this.addClass(order);
                if (order === 'asc') {
                    $this.removeClass('desc');
                } else {
                    $this.removeClass('asc');
                }
            }
        })
    },
    getVisiblePagesArray: function(iBeginPage, iEndPage, currentPage){
        var aPages = [];
        for(var i = iBeginPage; i <= iEndPage; i++){
            aPages.push({pageNo: i, currentPage: currentPage});
        }

        return aPages;
    },
    submitSortForm: function() {
        $('.js-sort-form').on('submit', function(event) {
            // Actually the sort select will change 2 parameters (query and sort). That is why we need to add them as hidden inputs.
            // The select itself therefore has no name (to not submit it).
            var selectedOption = $(this).find('select').find(':selected');
            
            var sort = selectedOption.val();
            var query = selectedOption.data('queryparameter');
            
            if (sort) {
                $(this).append('<input type="hidden" name="sort" value="' + sort + '"/>');
            } 
            if (query) {
                $(this).append('<input type="hidden" name="query" value="' + query + '"/>');
            } 
        });
    }
}

$(document).ready(function() {
    KMVP.searchandpagination.bindPaginationLinks();
    KMVP.searchandpagination.bindSortLinks();
    KMVP.searchandpagination.bindInputChangeToResetCurrentPage();
    KMVP.searchandpagination.submitSortForm();
});
